/**
 * Created by johannes on 15/05/2017.
 */
import * as Phaser from "phaser";
import {PlayState} from "./playstate";

import {LevelLoader} from "./levelloader";
import {Player} from "./player";
import Tilemap = Phaser.Tilemap;
import Point = Phaser.Point;
import game = PIXI.game;
import Key = Phaser.Key;


var layerinthTitle;
//var mainMenuButton;
export class MenuState extends Phaser.State {
    levelList = new Array();

    init() {
        //RESPONSIVE DESIGN WOOP WOOP :)
        this.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;
        this.game.scale.pageAlignVertically = true;
        this.game.scale.pageAlignHorizontally = true;
        this.game.scale.refresh();
       // if (this.game.device.desktop) {

            this.scale.maxHeight = (window.innerHeight* window.devicePixelRatio) > 900 ? 900 : (window.innerHeight* window.devicePixelRatio);
            this.scale.maxWidth = (window.innerWidth* window.devicePixelRatio) > 600 ? 600 : (window.innerWidth* window.devicePixelRatio);

        //}


            this.stage.backgroundColor = '#FFF';
    }


    preload() {
        this.game.load.spritesheet('menuButton','assets/images/Menubuttondouble.png',80,40);
        this.game.load.spritesheet('reloadButton','assets/images/Reloadbuttondouble.png',80,40);
        this.game.load.spritesheet('nextLevelButton','assets/images/nextlevelbutton.png',80,40);
        this.game.load.image('levelCompleteMessage', 'assets/images/level_complete.png');
        this.game.load.image('layerinth', 'assets/images/layerinth.png');
        this.game.load.image('easy', 'assets/images/easy.png');
        //this.game.load.image('medium', 'assets/images/medium.png');
        //this.game.load.image('hard', 'assets/images/hard.png');

        // levelbuttons
        for(let i = 1; i <= 15; i++){
            this.load.spritesheet('level'+i, 'assets/images/levelbuttons/'+i+'.png', 80,40);
        }


        for(let i = 1; i <= 15; i++){
            this.load.spritesheet('levelname'+i, 'assets/images/levelnames/level'+i+'.png', 80,40);
        }

        //FOR TOUCHSCREEN INPUT
        this.load.spritesheet('buttonup', 'assets/images/up.png', 48, 48);
        this.load.spritesheet('buttondown', 'assets/images/down.png', 48, 48);
        this.load.spritesheet('buttonleft', 'assets/images/left.png', 48, 48);
        this.load.spritesheet('buttonright', 'assets/images/right.png', 48, 48);
        this.load.spritesheet('buttonlayerup', 'assets/images/layerup.png', 48, 48);
        this.load.spritesheet('buttonlayerdown', 'assets/images/layerdown.png', 48, 48);
        //TOUCHSCREEN END

        // layer display
        this.load.image('00', 'assets/images/layers/0_0.png');
        this.load.image('10', 'assets/images/layers/1_0.png');
        this.load.image('11', 'assets/images/layers/1_1.png');
        this.load.image('20', 'assets/images/layers/2_0.png');
        this.load.image('21', 'assets/images/layers/2_1.png');
        this.load.image('22', 'assets/images/layers/2_2.png');
        this.load.image('30', 'assets/images/layers/3_0.png');
        this.load.image('31', 'assets/images/layers/3_1.png');
        this.load.image('32', 'assets/images/layers/3_2.png');
        this.load.image('33', 'assets/images/layers/3_3.png');
        // key
        this.load.spritesheet('key', 'assets/images/key.png', 48, 48);
        //this.load.spritesheet('nokey', 'assets/images/key.png', 48,48,96,48);

    }

    create() {
        layerinthTitle = this.game.add.sprite(this.game.width/2 -133,20, 'layerinth');

        this.game.add.sprite(this.game.width/2 -143, 100, 'easy').scale.set(0.85);

        for(let i = 1; i <= 5; i++) {
            this.levelList[i] = this.game.add.button(this.game.width/2 -150, 41 * i +90, 'level'+i,
                function() {PIXI.game.state.start('PlayState', true, false, i);},this,2,1,0);
            this.levelList[i].inputEnabled = true;
        }
        for(let i = 6; i <= 10; i++) {
            this.levelList[i] = this.game.add.button(this.game.width/2 -40, 41 * i -115, 'level'+i,
                function() {PIXI.game.state.start('PlayState', true, false, i);},this,2,1,0);
            this.levelList[i].inputEnabled = true;
        }
        for(let i = 11; i <= 15; i++) {
            this.levelList[i] = this.game.add.button(this.game.width/2 +70, 41 * i -320, 'level'+i,
                function() {PIXI.game.state.start('PlayState', true, false, i);},this,2,1,0);
            this.levelList[i].inputEnabled = true;
        }
    }
}




// WEBPACK FOOTER //
// ./src/menustate.ts